import React, { useState, useEffect } from 'react';
import Logo from '../../assets/Logo.svg';
import { addTeamMember, getTeamMembers } from '../../ApiController/ApiService';
import Swal from 'sweetalert2';
import { useDashboard } from '../Context/Dashboardcontext';

const TeamManagementModal = ({ isOpen, onClose, t }) => { // t for translation
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    userType: "",
  });
  const [teamMembers, setTeamMembers] = useState([]);
  const [error, setError] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState({});


const {FetchProfile,userProfile}=useDashboard()

useEffect(()=>{
FetchProfile()
},[])

console.log('userProfile',userProfile)

  const userTypeMap = {
    Admin: "USERADMIN",
    Dispatcher: "USERDISPATCHER",
    Driver: "DRIVER",
  };

  const allPermissions = [
    // "dashboard",
    "orders",
    "dispatch",
    "pod",
    "invoices",
    "reports",
    "drivers",
    "clientManagement",
    "companyProfile",
    "notifications",
    "messages"
  ];

  // Map permission keys to dynamic labels
  const permissionLabels = {
    // dashboard: t('sidebar.dashboard'),
    orders: t('sidebar.orders'),
    dispatch: t('sidebar.dispatch'),
    pod: t('sidebar.pod'),
    invoices: t('sidebar.invoices'),
    reports: t('sidebar.reports'),
    drivers: t('sidebar.drivers'),
    companyProfile: t('sidebar.companyProfile'),
    notifications: t('sidebar.notifications'),
    messages: t('sidebar.messages'),
    clientManagement:t('sidebar.clientManagement')
  };

  // Initialize permissions when role changes
  useEffect(() => {
    const initPermissions = {};
    allPermissions.forEach(p => initPermissions[p] = false);
    setPermissions(initPermissions);
  }, [formData.userType]);

  useEffect(() => {
    if (!isOpen) return;
    const fetchTeamMembers = async () => {
      try {
        const members = await getTeamMembers();
        setTeamMembers(members);
      } catch (err) {
        setFetchError(err.message || 'Failed to fetch team members');
      }
    };
    fetchTeamMembers();
  }, [isOpen]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePermissionToggle = (perm) => {
    setPermissions(prev => ({ ...prev, [perm]: !prev[perm] }));
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // Block USER type from adding team members
  if (userProfile.userType === "USERDISPATCHER") {
    Swal.fire({
      icon: 'warning',
      title: 'Access Denied',
      text: 'You have no access to add a team member.',
      confirmButtonColor: '#6F1AFF',
    });
    return; // Stop further execution
  }

  setIsLoading(true);
  setError(null);

  const userType = userTypeMap[formData.userType] || formData.userType;

  const selectedPermissions = Object.keys(permissions).filter(p => permissions[p]);

  const payload = {
    fullName: formData.fullName || "",
    email: formData.email || "",
    password: formData.password || "",
    userType: userType || "",
    permission: selectedPermissions || []
  };

  try {
    await addTeamMember(payload);

    await Swal.fire({
      icon: 'success',
      title: 'Success!',
      text: 'Team member added successfully.',
      confirmButtonText: 'OK',
      confirmButtonColor: '#6F1AFF',
    });

    // Reset form and reload team members
    setFormData({ fullName: "", email: "", password: "", userType: "" });
    setPermissions({});
    const members = await getTeamMembers();
    setTeamMembers(members);
onClose()
  } catch (err) {
    // Show error in Swal alert
    Swal.fire({
      icon: 'error',
      title: 'Error!',
      text: err.message || 'Failed to add team member.',
      confirmButtonColor: '#FF0000',
    });
    setError(err.message || 'Failed to add team member');
  } finally {
    setIsLoading(false);
  }
};


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
      <div className="relative bg-white rounded-2xl shadow-xl w-full max-w-[500px] max-h-[90vh] overflow-y-auto p-6">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-white bg-gray-800 p-2 rounded-full hover:bg-gray-700"
        >
          ✕
        </button>

        <img src={Logo} alt="Logo" className="mb-4 w-[200px] mx-auto" />

        <h2 className="text-2xl font-bold text-[#2D0076] text-center mb-2">Team Management</h2>
        <p className="text-sm text-[#202224] font-semibold text-center mb-4">
          Add team member details and assign permissions manually
        </p>

        {/* {fetchError && <div className="text-red-500 text-sm text-center mb-4">{fetchError}</div>} */}

        <div className={`mb-4 ${teamMembers.length > 3 ? 'max-h-[300px] overflow-y-auto hide-scrollbar' : ''}`}>
          {teamMembers.length > 0 ? (
            teamMembers.map(member => (
              <div key={member._id} className="bg-white rounded-xl mb-2 text-left border border-gray-200 overflow-hidden">
                <div className="flex justify-between bg-[#1D2461] items-center px-2 py-1">
                  <span className="text-[16px] font-semibold text-white">
                    {member.userType === "USERADMIN" ? "Admin" : member.userType === "USERDISPATCHER" ? "Dispatcher" : "Driver"}
                  </span>
                  <span className="text-[16px] font-semibold text-white">{member.userStatus}</span>
                </div>
                <div className="px-2 py-2">
                  <p className="font-bold text-[16px] text-[#1E1E1E] mb-1">{member.fullName}</p>
                  <p className="text-[14px] text-[#1E1E1E] mb-1">{member.email}</p>
                  <p className="text-sm text-gray-600">Permissions: {member.permission.join(', ')}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="text-sm text-[#202224] mb-2">No team members found.</p>
          )}
        </div>

        {error && <div className="text-red-500 text-sm text-center mb-4">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-3">
          <div className="text-left">
            <label className="block text-[16px] text-[#202224] mb-1">Member Role</label>
            <select
              name="userType"
              value={formData.userType}
              onChange={handleInputChange}
              className="w-full px-2 py-2 border bg-[#F1F4F9] text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            >
              <option value="">Select Member Role</option>
              {/* <option value="Admin">Admin</option> */}
              <option value="Dispatcher">Dispatcher</option>
              {/* <option value="Driver">Driver</option> */}
            </select>
          </div>

          <div className="text-left">
            <label className="block text-[16px] text-[#202224] mb-1">Name</label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Name"
              className="w-full px-4 py-2 border bg-[#F1F4F9] text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>

          <div className="text-left">
            <label className="block text-[16px] text-[#202224] mb-1">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="Email"
              className="w-full px-4 py-2 border bg-[#F1F4F9] text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
              required
            />
          </div>

          <div className="text-left">
            <label className="block text-[16px] text-[#202224] mb-1">Password</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Password"
              className="w-full px-4 py-2 border bg-[#F1F4F9] text-black border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          {/* Permissions Switch */}
          <div className="text-left">
            <label className="block text-[16px] text-black mb-1">Assign Permissions</label>
            <div className="grid grid-cols-2 gap-2">
              {allPermissions.map(perm => (
                <div key={perm} className="flex items-center justify-between bg-gray-100 px-2 py-1 rounded">
                  <span className="text-black text-sm">{permissionLabels[perm]}</span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={permissions[perm] || false}
                      onChange={() => handlePermissionToggle(perm)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-300 rounded-full peer peer-checked:bg-purple-600 transition-all"></div>
                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md peer-checked:translate-x-5 transition-all"></div>
                  </label>
                </div>
              ))}
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`w-full bg-[#6F1AFF] text-white font-semibold py-2 rounded-md transition ${isLoading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#6939e8]'}`}
          >
            {isLoading ? 'Adding...' : 'Add Member'}
          </button>
        </form>

        <style>{`
          .hide-scrollbar::-webkit-scrollbar {
            display: none;
          }
        `}</style>
      </div>
    </div>
  );
};

export default TeamManagementModal;
